import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRetweet,
  faArrowCircleLeft,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCalendarCheck,
  faArrowCircleRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faRetweet);
library.add(faArrowCircleLeft);
library.add(faChevronCircleLeft);
library.add(faChevronCircleRight);
library.add(faCalendarCheck);
library.add(faArrowCircleRight);

Vue.component("font-awesome-icon", FontAwesomeIcon);
export default Vue;